import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { config } from "../config";
import ROUTES from "../routes";
import { baseApi } from "../services/base";
import { revertAll } from "../store/slice/globalSlice";
import { useLazyUserLogoutQuery } from "../services/user";

const InactivityTracker = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const inactivityTimerRef = useRef(null);
	const [trigger] = useLazyUserLogoutQuery();

	const signOut = async () => {
		const response = await trigger().unwrap();
		if (response.success) {
			localStorage.removeItem(config.accessTokenName);
			dispatch(baseApi.util.resetApiState());
			dispatch(revertAll());
			navigate(ROUTES.PATHS.LOGIN);
		}
	};

	const resetInactivityTimer = () => {
		if (inactivityTimerRef.current) {
			clearTimeout(inactivityTimerRef.current);
		}

		inactivityTimerRef.current = setTimeout(() => {
			signOut();
		}, 10800000); // 3 hours in milliseconds
	};

	const setUpInactivityTracker = () => {
		window.addEventListener("mousemove", resetInactivityTimer);
		window.addEventListener("keydown", resetInactivityTimer);
		window.addEventListener("click", resetInactivityTimer);
		window.addEventListener("scroll", resetInactivityTimer);

		// Initialize the timer when the app starts
		resetInactivityTimer();
	};

	useEffect(() => {
		setUpInactivityTracker();

		return () => {
			window.removeEventListener("mousemove", resetInactivityTimer);
			window.removeEventListener("keydown", resetInactivityTimer);
			window.removeEventListener("click", resetInactivityTimer);
			window.removeEventListener("scroll", resetInactivityTimer);
		};
	}, []);

	return null; // This component doesn't render anything
};

export default InactivityTracker;
